module.exports = __webpack_public_path__ + "img/dining_table_material.6abfec1.jpg";